import { createSvgComponent } from "../../icon/createSvgComponent";
import ArrowRight from "@core/__generated__/icon/figma/arrow-right.svg";
export default createSvgComponent(ArrowRight);